export enum Theme {
  address = 'address',
  app = 'app',
  hours = 'hours',
  kiosk = 'kiosk',
  mail = 'mail',
  mobile = 'mobile',
  phone = 'phone',
  retail = 'retail',
  shop = 'shop',
  watch = 'watch',
}

export interface Props {
  theme?: Theme,
}
